import { render, staticRenderFns } from "./ChangePurchaseTax.vue?vue&type=template&id=f8ae10f8&scoped=true"
import script from "./ChangePurchaseTax.vue?vue&type=script&lang=js"
export * from "./ChangePurchaseTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ae10f8",
  null
  
)

export default component.exports